/* eslint-disable @typescript-eslint/ban-ts-comment */
/**
 * @description Browser cookie processing
 * @source  https://github.com/steamerjs/steamer-browserutils
 * 正则表达式网站  http://www.regexr.com/
 */
import global from '../base/global';
import { has } from '../object';
import { isObject } from '../types';
// 默认cookie存30天
var DEFAULT_EXPIRE_DAYS = 30 * 24 * 60 * 60 * 1000;
// 一天的毫秒数
var TIMEINTERVAL_OF_DAY = 24 * 60 * 60 * 1000;
// document 属性名
var DOCUMENT_PREPROTY = 'document';
/**
 * ark 目前支持的常用cookie字段集合。
 * 建议不要直接使用setCookie和getCookie
 */
export var COMMON_COOKIES_KEYS;
(function (COMMON_COOKIES_KEYS) {
    /**
     * cgi相关 xsrf token
     */
    COMMON_COOKIES_KEYS["xsrf"] = "TOK";
    /**
     * 测试环境相关   测试环境routeId
     */
    COMMON_COOKIES_KEYS["devRouteId"] = "dev_route_id";
    /**
     * 测试环境相关   测试环境登录账号名
     */
    COMMON_COOKIES_KEYS["devOaName"] = "dev_oa_name";
    /**
     * 测试环境相关   测试环境FD
     */
    COMMON_COOKIES_KEYS["fd"] = "fd";
    /**
     * 测试环境相关   env_id 后期epc统计相关字段
     */
    COMMON_COOKIES_KEYS["envId"] = "env_id";
    /**
     * 登录态相关
     * 登录态判断和取当前登录用户信息不要直接用Cookie判断
     * 取UserInfoDomainService的isLogin来判断是否登录
     * uid 取UserInfoDomainService里UserInfo.tinyid
     */
    /**
     * 登录态相关   多登录态SID
     */
    COMMON_COOKIES_KEYS["sid"] = "SID";
    /**
     * 登录态相关   多登录态SIDS
     */
    COMMON_COOKIES_KEYS["sids"] = "SID_S";
    /**
     * 登录态相关   uid
     */
    COMMON_COOKIES_KEYS["uid"] = "uid";
    /**
     * 登录态相关   uid_key
     */
    COMMON_COOKIES_KEYS["uidKey"] = "uid_key";
    /**
     * 登录态相关   uin QQ号
     */
    COMMON_COOKIES_KEYS["uin"] = "uin";
    /**
     * 登录态相关   登录时间
     */
    COMMON_COOKIES_KEYS["loginTime"] = "loginTime";
    /**
     * 登录态相关   是否已登录
     */
    COMMON_COOKIES_KEYS["hasBeenLogin"] = "has_been_login";
    /**
     * 其它   渠道号
     */
    COMMON_COOKIES_KEYS["adtag"] = "adtag";
    /**
     * QQ登录字段
     */
    COMMON_COOKIES_KEYS["plUin"] = "p_luin";
    /**
     * QQ登录字段
     */
    COMMON_COOKIES_KEYS["pUin"] = "p_uin";
    /**
     * QQ登录字段
     */
    COMMON_COOKIES_KEYS["pSkey"] = "p_skey";
    /**
     * QQ登录字段
     */
    COMMON_COOKIES_KEYS["plSkey"] = "p_lskey";
})(COMMON_COOKIES_KEYS || (COMMON_COOKIES_KEYS = {}));
/**
 * object类型为转string
 * @param val
 * @returns
 */
function privateStringify(val) {
    return isObject(val) ? JSON.stringify(val) : val;
}
/**
 * set cookie
 * @param {string} key            [key]
 * @param {any} val               [value]
 * @param {number options} days   [days]
 * @param {string options} path   [path]
 * @param {string options} domain [domain]
 */
export function setCookie(key, val, days, path, domain) {
    if (!has(global, DOCUMENT_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return;
    }
    var value = encodeURIComponent(privateStringify(val));
    // 浏览器环境，直接操作；
    // 计算保存时长, 默认cookie存30天
    var expireIntervals = DEFAULT_EXPIRE_DAYS;
    if (days) {
        expireIntervals = TIMEINTERVAL_OF_DAY * days;
    }
    // 生成过期时间expire
    var expire = new Date();
    expireIntervals = expireIntervals + expire.getTime();
    expire.setTime(expireIntervals);
    var gmtExpire = expire.toUTCString();
    // 可选参数处理
    var finalPath = path ? path : '/';
    var finalDomain = domain ? ("domain=".concat(domain, ";")) : '';
    // set cookie
    document.cookie = "".concat(key, "=").concat(value, ";expires=").concat(gmtExpire, ";path=").concat(finalPath, ";").concat(finalDomain);
}
/**
 * del cookie
 * @param  {string} key    [key]
 * @param  {string} path   [path]
 * @param  {string} domain [domain]
 */
export function delCookie(key, path, domain) {
    if (!has(global, DOCUMENT_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return;
    }
    // 可选参数处理
    var finalPath = path ? path : '/';
    var finalDomain = domain ? ("domain=".concat(domain, ";")) : '';
    // 生成过期时间expire
    var expire = new Date(0);
    var gmtExpire = expire.toUTCString();
    // del cookie
    document.cookie = "".concat(key, "=;expires=").concat(gmtExpire, ";path=").concat(finalPath, ";").concat(finalDomain);
}
/**
 * get cookie
 * @param  {string} key [key]
 * @return {string}     [cookie value]
 */
export function getCookie(key) {
    if (!has(global, DOCUMENT_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return null;
    }
    var reg = new RegExp("(?:^|;+|\\s+)".concat(key, "=([^;]*)"));
    var result = document.cookie.match(reg);
    return (!result ? null : result[1]) || null;
}
/**
 * 通过对应的Key，获取常用的Cookie值
 * @returns string 或者 null
 */
export function getCookieByCommonKey(key) {
    return getCookie(key);
}
/**
 * 获取 uin，现在是从 cookie 上的 p_uin 字段获取
 * 默认为 null ，而不是空字符串
 */
export function getCookieUin() {
    var uin = null;
    var uinInCookie = getCookie('p_luin') || getCookie('p_uin');
    if (uinInCookie) {
        uin = uinInCookie.replace(/^[o0]+/i, '');
    }
    return uin;
}
/**
 * 获取 cookie 中的 uid
 *  默认为 null ，而不是空字符串
 */
export function getCookieUid() {
    return getCookie('uid') || null;
}
